import api from '@/api';

export type ByokStatus = {
  status?: string;
  mode?: 'hosted' | 'byok';
  byokServerEnabled?: boolean;
  planAllowsByok?: boolean;
  planInRollout?: boolean;
  canConfigureByok?: boolean;
  isAccountAdmin?: boolean;
  keyLast4?: string | null;
  provider?: string | null;
  endpoint?: string | null;
  chatModel?: string | null;
  validatedAt?: number | null;
  disabledReason?: string | null;
  enabled?: boolean;
};

export type ByokValidationChecks = {
  embed: boolean;
  chat: boolean;
};

export type ByokAuditEntry = {
  action: string;
  actorUid: string;
  actorEmail?: string;
  at?: { _seconds?: number } | number;
  provider?: string;
  keyLast4?: string;
  enabled?: boolean;
  result?: boolean;
  reason?: string;
};

export type ByokSaveParams = {
  apiKey: string;
  provider?: string;
  endpoint?: string;
  chatModel?: string;
  enabled?: boolean;
};

export type ByokTestParams = ByokSaveParams;

export async function fetchByokStatus(): Promise<ByokStatus> {
  const res = await api.get<ByokStatus>('/ai/byok/status');
  return res.data ?? {};
}

export async function fetchByokAudit(limit = 5): Promise<ByokAuditEntry[]> {
  const res = await api.get<{ items?: ByokAuditEntry[] }>('/ai/byok/audit', { params: { limit } });
  return res.data?.items ?? [];
}

export async function testByokConnection(params: ByokTestParams): Promise<{ ok: boolean; checks?: ByokValidationChecks }> {
  const res = await api.post<{ ok?: boolean; checks?: ByokValidationChecks }>('/ai/byok/test', {
    provider: params.provider ?? 'openai',
    apiKey: params.apiKey,
    endpoint: params.endpoint,
    chatModel: params.chatModel,
  });
  return { ok: res.data?.ok === true, checks: res.data?.checks };
}

export async function saveByokKey(params: ByokSaveParams): Promise<void> {
  await api.post('/ai/byok', {
    provider: params.provider ?? 'openai',
    apiKey: params.apiKey,
    endpoint: params.endpoint,
    chatModel: params.chatModel,
    enabled: params.enabled ?? true,
  });
}

export async function setByokEnabled(enabled: boolean): Promise<void> {
  await api.patch('/ai/byok', { enabled });
}

export async function deleteByokKey(): Promise<void> {
  await api.delete('/ai/byok');
}
